import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'logistics_hongde_merchant_page',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '派单方',
        addFunName: 'mngUserAdd',
        modifyFunName: 'mngUserModify',
        delFunName: 'logisticHongdeMerchantDel',
        queryFunName: 'logisticHongdeMerchantQuery',
        detailFunName: 'mngUserDetail',
        disableFunName: 'mngUserDisable',
        unDisableFunName: 'mngUserUnDisable',
        EvalSwitchName: 'logisticHongdeMerchantEvalSwitch',
        unLockFunName: 'mngUserUnLock',
        resetPasswordFunName: 'mngUserResetPassword',
        clearAuthFunName: 'mngUserClearAuth',
        detailMerchantFunName: 'logisticHongdeMerchantDetail',
        addMerchantFunName: 'logisticHongdeMerchantAdd',
        addQuotaFunName: 'logisticHongdeMerchantAddQuota',
        successMerchantFunNane: 'logisticHongdeMerchantSuccess',
        failMerchantFunNane: 'logisticHongdeMerchantFail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        logisticHongdeCarTeamDetail: "logisticHongdeCarTeamDetail"
      },
      searchForm: {
        page: 1,
        limit: 10,
        authState: null,
        searchKey: null,
        userState: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        category: 'mng_user_category_hd_merchant',
        state: 'active',
        remark: null,
        phone: null
      },
      formMerchantData: {
        id: null,
        legal: null,
        level: null,
        userId: null,
        nickname: null,
        contactPhone: null,
        authState: 'Success',
        legalIdentityCard: null,
        legalIdentityCardImageFront: null,
        legalIdentityCardImageBack: null,
        socialUniformCreditCode: null,
        businessLicenseImage: null,
        businessLicenseName: null
      },
      rules: {
        phone: [{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: '请选择状态',
          trigger: 'blur'
        }]
      },
      merchantRules: {
        businessLicenseName: [{
          required: true,
          message: '营业执照名称不能为空',
          trigger: 'blur'
        }],
        legal: [{
          required: true,
          message: '法人不能为空',
          trigger: 'blur'
        }],
        legalIdentityCard: [{
          required: true,
          message: '法人身份证不能为空',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '联系方式不能为空',
          trigger: 'blur'
        }],
        socialUniformCreditCode: [{
          required: true,
          message: '社会统一信用代码不能为空',
          trigger: 'blur'
        }],
        businessLicenseImage: [{
          required: true,
          message: '营业执照照片不能为空',
          trigger: 'blur'
        }],
        legalIdentityCardImageFront: [{
          required: true,
          message: '法人身份证照片不能为空',
          trigger: 'blur'
        }],
        legalIdentityCardImageBack: [{
          required: true,
          message: '法人身份证照片不能为空',
          trigger: 'blur'
        }],
        authState: [{
          required: true,
          message: '状态不能为空',
          trigger: 'blur'
        }]
      },
      dicData: {
        upperLevelCode: 'logistics_hd_merchant_level',
        configLevels: [],
        configLevelOptions: {}
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      editMerchantDialogShow: false,
      formLabelWidth: '100px',
      formCardLabelWidth: '120px',
      emptyFormData: {},
      emptyMerchantFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.emptyMerchantFormData = JSON.parse(JSON.stringify(this.formMerchantData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.upperLevelCode).then(function (res) {
        if (res.data) {
          _this.dicData.configLevels = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configLevelOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'edit':
          // 帐号编辑
          this.edit(command.row.userUserId);
          break;
        case 'unLock':
          // 解除锁定
          this.unLock(command.row.userUserId);
          break;
        case 'disable':
          // 封禁用户
          this.disableUser(command.row.userUserId);
          break;
        case 'unDisable':
          // 解封用户
          this.unDisableUser(command.row.userUserId);
          break;
        case 'resetPassword':
          // 重置密码
          this.resetPassword(command.row.userUserId);
          break;
        case 'clear':
          // 清理用户
          this.clearUser(command.row.userUserId);
          break;
        case 'unEval':
          // 禁用评价
          this.operateEval(command.row.id, false);
          break;
        case 'Eval':
          // 开启评价
          this.operateEval(command.row.id, true);
          break;
        case 'addQuota':
          // 增加授信额度
          this.addQuota(command.row);
          break;
        case 'success':
          // 通过
          this.success(command.row.id);
          break;
        case 'fail':
          // 拒绝
          this.fail(command.row.id);
          break;
        case 'seeEval':
          // 查看评价
          this.seeEval(command.row);
          break;
        case 'carTeam':
          // 查看评价
          this.carTeam(command.row);
          break;
      }
    },
    unLock: function unLock(userId) {
      var _this2 = this;
      this.$confirm('确定解锁当前派单方吗').then(function () {
        _this2.$api[_this2.pageConfig.unLockFunName](userId).then(function (res) {
          if (res.data) {
            _this2.$message.success('解锁成功');
            _this2.query();
          } else {
            _this2.$message.error('解锁失败');
          }
        });
      });
    },
    disableUser: function disableUser(userId) {
      var _this3 = this;
      this.$confirm('确定封禁当前派单方吗').then(function () {
        _this3.$api[_this3.pageConfig.disableFunName](userId).then(function (res) {
          if (res.data) {
            _this3.$message.success('封禁成功');
            _this3.query();
          } else {
            _this3.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(userId) {
      var _this4 = this;
      this.$confirm('确定解禁当前派单方吗').then(function () {
        _this4.$api[_this4.pageConfig.unDisableFunName](userId).then(function (res) {
          if (res.data) {
            _this4.$message.success('解禁成功');
            _this4.query();
          } else {
            _this4.$message.error('解禁失败');
          }
        });
      });
    },
    resetPassword: function resetPassword(userId) {
      var _this5 = this;
      this.$confirm('确定重置当前派单方密码吗').then(function () {
        _this5.$api[_this5.pageConfig.resetPasswordFunName](userId).then(function (res) {
          if (res.data) {
            _this5.$message.success('重置成功');
            _this5.query();
          } else {
            _this5.$message.error('重置失败');
          }
        });
      });
    },
    clearUser: function clearUser(userId) {
      var _this6 = this;
      this.$confirm('确定清除用户吗？用户清除后将不能恢复').then(function () {
        _this6.$confirm('请再次确认，是否清除当前用户？').then(function () {
          _this6.$confirm('请谨慎操作！！！最后确认是否清除当前用户？').then(function () {
            _this6.$api[_this6.pageConfig.clearAuthFunName](userId).then(function (res) {
              if (res.data) {
                _this6.$message.success('清除成功');
                _this6.query();
              } else {
                _this6.$message.error('清除失败');
              }
            });
          });
        });
      });
    },
    operateEval: function operateEval(id, flag) {
      var _this7 = this;
      this.$confirm(flag ? '确定开启评价吗?' : '确定关闭评价吗?').then(function () {
        _this7.$api[_this7.pageConfig.EvalSwitchName](id, flag).then(function (res) {
          if (res.data) {
            _this7.$message.success(flag ? '开启成功' : '关闭成功');
            _this7.query();
          } else {
            _this7.$message.error(flag ? '开启失败' : '关闭失败');
          }
        });
      });
    },
    addQuota: function addQuota(row) {
      var _this8 = this;
      this.$prompt('请输入', "\u300A".concat(row.businessLicenseName, "\u300B\u589E\u52A0\u6388\u4FE1\u989D\u5EA6"), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
        inputErrorMessage: '必须为有效金额'
      }).then(function (_ref) {
        var value = _ref.value;
        _this8.$api[_this8.pageConfig.addQuotaFunName](row.id, value * 100).then(function (res) {
          _this8.$message.success('操作成功');
          _this8.query();
        });
      }).catch(function () {});
    },
    success: function success(id) {
      var _this9 = this;
      this.$confirm('是否通过认证?', '通过认证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this9.$api[_this9.pageConfig.successMerchantFunNane](id).then(function (res) {
          _this9.$message.success('操作成功');
          _this9.query();
        });
      }).catch(function () {});
    },
    fail: function fail(id) {
      var _this10 = this;
      this.$prompt('请填写驳回的原因', '驳回认证', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写驳回原因'
      }).then(function (_ref2) {
        var value = _ref2.value;
        _this10.$api[_this10.pageConfig.failMerchantFunNane](id, value).then(function (res) {
          _this10.$message.success('操作成功');
          _this10.query();
        });
      }).catch(function () {});
    },
    seeEval: function seeEval(id) {
      this.goChild(id, 'merchantEval');
    },
    carTeam: function carTeam(id) {
      this.goChild(id, 'merchantCarTeam');
    },
    goChild: function goChild(id, tableName) {
      this.$emit('child-go', id, tableName);
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    initMerchantFormData: function initMerchantFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formMerchantData = paramData;
      if (typeof this.$refs['formMerchantDataVerify'] !== 'undefined') {
        this.$refs['formMerchantDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    saveMechantFormDataProcess: function saveMechantFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadBusinessLicenseImage: function uploadBusinessLicenseImage(_ref3) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref3.file;
              _this11.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this11.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this11.formMerchantData.businessLicenseImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    uploadCardFrontImage: function uploadCardFrontImage(_ref5) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref5.file;
              _this12.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this12.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this12.formMerchantData.legalIdentityCardImageFront = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    uploadCardBackImage: function uploadCardBackImage(_ref7) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref7.file;
              _this13.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this13.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this13.formMerchantData.legalIdentityCardImageBack = _context5.sent;
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    removeFile: function removeFile() {
      this.formData.image = '';
    },
    removeMerchantFile: function removeMerchantFile() {
      this.formMerchantData.image = '';
    },
    removeIdentityCardImageFrontFile: function removeIdentityCardImageFrontFile() {
      this.formMerchantData.legalIdentityCardImageFront = '';
    },
    removeIdentityCardImageBackFile: function removeIdentityCardImageBackFile() {
      this.formMerchantData.legalIdentityCardImageBack = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this14 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this14.initFormData(res.data);
        _this14.editDialogTitle = _this14.pageConfig.editPageName + '维护';
        _this14.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this15 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this15.$api[_this15.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this15.$message.success('删除成功');
            _this15.query();
          } else {
            _this15.$message.error('删除失败');
          }
        });
      });
    },
    merchantEdit: function merchantEdit(rowData) {
      var _this16 = this;
      console.log(rowData, "rowData");
      this.$api[this.pageConfig.logisticHongdeCarTeamDetail](rowData.carTeamId).then(function (res) {
        console.log(res, "res-----");
        if (res.data) {
          rowData.carTeamName = res.data.name, rowData.carTeamLeaderName = res.data.leader;
          rowData.carTeamLeaderPhone = res.data.leaderPhone;
        }
        _this16.initMerchantFormData(rowData);
        _this16.pageConfig.addMerchantFunName = 'logisticHongdeMerchantModifyAuth';
        _this16.formMerchantData.nickname = rowData.nickname || '';
        _this16.editMerchantDialogShow = true;
      });

      // this.$api[this.pageConfig.detailMerchantFunName](rowData.id).then((res) => {
      //   console.log(res.data,"res.datares.datares.data")

      //   // if (res.data) {
      //   //   this.initMerchantFormData(res.data)
      //   //   this.pageConfig.addMerchantFunName = 'logisticHongdeMerchantModifyAuth'
      //   // } else {
      //   //   this.formMerchantData.userId = rowData.userUserId
      //   //   this.pageConfig.addMerchantFunName = 'logisticHongdeMerchantAdd'
      //   // }

      //   // this.formMerchantData.nickname = rowData.nickname || ''

      //   // this.editMerchantDialogShow = true
      // })
    },
    query: function query() {
      var _this17 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this17.tableData = res.data || [];
        _this17.totalCount = res.count;
        _this17.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this18 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this18.formData.id) {
            _this18.$api[_this18.pageConfig.modifyFunName](_this18.saveFormDataProcess(_this18.formData)).then(function (res) {
              if (res.data) {
                _this18.$message.success('编辑成功');
                _this18.initFormData(_this18.emptyFormData);
                _this18.editDialogShow = false;
                _this18.query();
              } else {
                _this18.$message.error('编辑失败');
              }
            });
          } else {
            _this18.$api[_this18.pageConfig.addFunName](_this18.saveFormDataProcess(_this18.formData)).then(function (res) {
              if (res.data) {
                _this18.$message.success('新增成功');
                _this18.initFormData(_this18.emptyFormData);
                _this18.editDialogShow = false;
                _this18.query();
              } else {
                _this18.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    submitMerchantFormData: function submitMerchantFormData() {
      var _this19 = this;
      this.$refs['formMerchantDataVerify'].validate(function (valid) {
        if (valid) {
          _this19.$api[_this19.pageConfig.addMerchantFunName](_this19.saveMechantFormDataProcess(_this19.formMerchantData)).then(function (res) {
            if (res.data) {
              _this19.$message.success('派单方信息维护成功');
              _this19.initMerchantFormData(_this19.emptyMerchantFormData);
              _this19.editMerchantDialogShow = false;
              _this19.query();
            } else {
              _this19.$message.error('派单方信息维护失败');
            }
          });
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    closeMerchantEditDialogShow: function closeMerchantEditDialogShow() {
      this.editMerchantDialogShow = false;
      this.initMerchantFormData(this.emptyMerchantFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};